import { render, staticRenderFns } from "./VesselComparison.vue?vue&type=template&id=2192fdc6&scoped=true&"
import script from "./VesselComparison.vue?vue&type=script&lang=ts&"
export * from "./VesselComparison.vue?vue&type=script&lang=ts&"
import style0 from "./VesselComparison.vue?vue&type=style&index=0&id=2192fdc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2192fdc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
